import React from 'react';

// Small, modern BETA pill used across the platform to flag applications that
// are still in beta. Designed to sit inline next to an app title without
// clashing with Derwent's clean #f4f4f4 / #1d1d1d aesthetic.
const SIZES = {
  xs: 'text-[8.5px] px-1.5 py-[1px] tracking-[0.14em]',
  sm: 'text-[9.5px] px-2 py-[2px] tracking-[0.16em]',
  md: 'text-[10.5px] px-2.5 py-[3px] tracking-[0.18em]',
};

const TONES = {
  light: 'bg-emerald-50 text-emerald-700 ring-emerald-200/70',
  dark: 'bg-white/10 text-white ring-white/25 backdrop-blur-sm',
  slate: 'bg-slate-900 text-emerald-300 ring-slate-800',
};

const BetaBadge = ({ size = 'sm', tone = 'light', className = '' }) => (
  <span
    data-testid="beta-badge"
    aria-label="Beta"
    className={`inline-flex items-center gap-1 font-black uppercase rounded-full ring-1 align-middle select-none ${SIZES[size] || SIZES.sm} ${TONES[tone] || TONES.light} ${className}`}
  >
    <span className={`w-1 h-1 rounded-full ${tone === 'dark' ? 'bg-emerald-300' : 'bg-emerald-500'} animate-pulse`} />
    Beta
  </span>
);

export default BetaBadge;
